import type { ComponentType } from 'react';

import { Sparkles } from 'lucide-react';

import { CustomCircleTickIcon } from '@nesso/ui/icons/custom-circle-tick';
import { CustomTriangleDangerIcon } from '@nesso/ui/icons/custom-triangle-danger';

import type { SessionListItem, SessionNoteStatus } from '@/entities/session';

type StatusIcon = {
    Icon: ComponentType<{ className?: string }>;
    label: string;
    className?: string;
    iconClassName?: string;
};

type Status = SessionNoteStatus | 'REVIEW_NOTE';

type Options = {
    suppress: Status[];
};

const sessionStatusMap: Record<Status, StatusIcon> = {
    DONE: {
        Icon: CustomCircleTickIcon,
        label: 'Done',
        className: undefined,
        iconClassName: 'h-4 w-4 text-toast-success',
    },
    TODO: {
        Icon: CustomTriangleDangerIcon,
        label: 'To-Do',
        className: undefined,
        iconClassName: 'h-4 w-4 text-toast-warning',
    },
    REVIEW_NOTE: {
        Icon: Sparkles,
        label: 'New',
        className: 'font-bold',
        iconClassName: 'h-4 w-4 text-secondary',
    },
};

export function getSessionStatusIcon(
    session: SessionListItem,
    options: Options = { suppress: [] },
): StatusIcon | undefined {
    const hasReviewNoteAction = session.actions.includes('REVIEW_NOTE');
    const sessionNoteStatus = session.currentNote?.status || null;
    const sessionStatus = hasReviewNoteAction ? 'REVIEW_NOTE' : sessionNoteStatus;

    return sessionStatus && !options.suppress.includes(sessionStatus)
        ? sessionStatusMap[sessionStatus]
        : undefined;
}
